module.exports = __webpack_public_path__ + "img/pr-3.5f7e5550.png";